"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var CommonNetworkMember_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonNetworkMember = void 0;
const async_retry_1 = __importDefault(require("async-retry"));
const common_1 = require("@affinidi/common");
const vc_common_1 = require("@affinidi/vc-common");
const did_resolver_1 = require("did-resolver");
const affinity_metrics_lib_1 = require("@affinidi/affinity-metrics-lib");
const ApiService_1 = __importDefault(require("./services/ApiService"));
const CognitoService_1 = __importDefault(require("./services/CognitoService"));
const SdkError_1 = __importDefault(require("./shared/SdkError"));
const WalletStorageService_1 = __importDefault(require("./services/WalletStorageService"));
const RevocationService_1 = __importDefault(require("./services/RevocationService"));
const HolderService_1 = __importDefault(require("./services/HolderService"));
const PhoneIssuerService_1 = require("./services/PhoneIssuerService");
const EmailIssuerService_1 = require("./services/EmailIssuerService");
const shared_dto_1 = require("./dto/shared.dto");
const validateUsername_1 = require("./shared/validateUsername");
const ParametersValidator_1 = require("./shared/ParametersValidator");
const randomBytes_1 = require("./shared/randomBytes");
const normalizeShortPassword_1 = require("./shared/normalizeShortPassword");
const normalizeUsername_1 = require("./shared/normalizeUsername");
const sessionStorageHandler_1 = require("./shared/sessionStorageHandler");
const _helpers_1 = require("./_helpers");
const _defaultConfig_1 = require("./_defaultConfig");
let CommonNetworkMember = CommonNetworkMember_1 = class CommonNetworkMember {
    constructor(password, encryptedSeed, options = {}, component) {
        // await ParametersValidator.validateSync(
        //   [
        //     { isArray: false, type: 'string', isRequired: true, value: password },
        //     { isArray: false, type: 'string', isRequired: true, value: encryptedSeed },
        //     { isArray: false, type: SdkOptions, isRequired: false, value: options }
        //   ]
        // )
        if (!password || !encryptedSeed) {
            // TODO: implement appropriate error wrapper
            throw new Error('`password` and `encryptedSeed` must be provided!');
        }
        this._sdkOptions = CommonNetworkMember_1.setEnvironmentVarialbles(options);
        const { issuerUrl, metricsUrl, registryUrl, verifierUrl, phoneIssuerBasePath, emailIssuerBasePath, } = this._sdkOptions;
        this._accessApiKey = this._sdkOptions.accessApiKey;
        this._component = component || affinity_metrics_lib_1.EventComponent.AffinidiCore;
        this._metricsService = new common_1.MetricsService({
            metricsUrl,
            accessApiKey: this._accessApiKey,
            component: this._component,
        });
        this._api = new ApiService_1.default(registryUrl, issuerUrl, verifierUrl, { accessApiKey: this._accessApiKey });
        this._walletStorageService = new WalletStorageService_1.default(encryptedSeed, password, this._sdkOptions);
        this._revocationService = new RevocationService_1.default(this._sdkOptions);
        this._keysService = new common_1.KeysService(encryptedSeed, password);
        this._jwtService = new common_1.JwtService();
        this._holderService = new HolderService_1.default(this._sdkOptions, this._component);
        this._didDocumentService = new common_1.DidDocumentService(this._keysService);
        this._affinity = new common_1.Affinity({
            apiKey: this._accessApiKey,
            registryUrl: registryUrl,
            metricsUrl: metricsUrl,
            component: this._component,
        });
        this._encryptedSeed = encryptedSeed;
        this._password = password;
        this.cognitoUserTokens = options && options.cognitoUserTokens ? options.cognitoUserTokens : undefined;
        this._did = null;
        this._didDocumentKeyId = null;
        this._phoneIssuer = new PhoneIssuerService_1.PhoneIssuerService({ basePath: phoneIssuerBasePath });
        this._emailIssuer = new EmailIssuerService_1.EmailIssuerService({ basePath: emailIssuerBasePath });
    }
    static _setAccessApiKey(options) {
        let apiKey;
        let accessApiKey;
        let apiKeyBuffer;
        accessApiKey = options.accessApiKey;
        const useTestApiKey = !options.apiKey && !options.accessApiKey;
        if (useTestApiKey) {
            apiKey = 'testApiKey';
            apiKeyBuffer = common_1.KeysService.sha256(Buffer.from(apiKey));
            accessApiKey = apiKeyBuffer.toString('hex');
        }
        if (options.apiKey) {
            apiKeyBuffer = common_1.KeysService.sha256(Buffer.from(options.apiKey));
            accessApiKey = apiKeyBuffer.toString('hex');
        }
        return accessApiKey;
    }
    static setEnvironmentVarialbles(options) {
        const env = options.env || 'staging';
        let vaultUrl;
        let issuerUrl;
        let registryUrl;
        let verifierUrl;
        let keyStorageUrl;
        let clientId;
        let userPoolId;
        let revocationUrl;
        let phoneIssuerBasePath;
        let emailIssuerBasePath;
        let metricsUrl;
        switch (env) {
            /* istanbul ignore next */
            case 'dev':
                issuerUrl = options.issuerUrl || _defaultConfig_1.DEV_ISSUER_URL;
                registryUrl = options.registryUrl || _defaultConfig_1.DEV_REGISTRY_URL;
                verifierUrl = options.verifierUrl || _defaultConfig_1.DEV_VERIFIER_URL;
                vaultUrl = options.vaultUrl || _defaultConfig_1.DEV_VAULT_URL;
                keyStorageUrl = options.keyStorageUrl || _defaultConfig_1.DEV_KEY_STORAGE_URL;
                clientId = _defaultConfig_1.DEV_COGNITO_CLIENT_ID;
                userPoolId = _defaultConfig_1.DEV_COGNITO_USER_POOL_ID;
                clientId = _defaultConfig_1.DEV_COGNITO_CLIENT_ID;
                userPoolId = _defaultConfig_1.DEV_COGNITO_USER_POOL_ID;
                phoneIssuerBasePath = options.phoneIssuerBasePath || _defaultConfig_1.DEV_PHONE_ISSUER_BASE_PATH;
                emailIssuerBasePath = options.emailIssuerBasePath || _defaultConfig_1.DEV_EMAIL_ISSUER_BASE_PATH;
                metricsUrl = _defaultConfig_1.DEV_METRICS_URL;
                revocationUrl = options.revocationUrl || _defaultConfig_1.DEV_REVOCATION_URL;
                break;
            /* istanbul ignore next */
            case 'prod':
                issuerUrl = options.issuerUrl || _defaultConfig_1.PROD_ISSUER_URL;
                registryUrl = options.registryUrl || _defaultConfig_1.PROD_REGISTRY_URL;
                verifierUrl = options.verifierUrl || _defaultConfig_1.PROD_VERIFIER_URL;
                vaultUrl = options.vaultUrl || _defaultConfig_1.PROD_VAULT_URL;
                keyStorageUrl = options.keyStorageUrl || _defaultConfig_1.PROD_KEY_STORAGE_URL;
                clientId = _defaultConfig_1.PROD_COGNITO_CLIENT_ID;
                userPoolId = _defaultConfig_1.PROD_COGNITO_USER_POOL_ID;
                phoneIssuerBasePath = options.phoneIssuerBasePath || _defaultConfig_1.PROD_PHONE_ISSUER_BASE_PATH;
                emailIssuerBasePath = options.emailIssuerBasePath || _defaultConfig_1.PROD_EMAIL_ISSUER_BASE_PATH;
                metricsUrl = _defaultConfig_1.PROD_METRICS_URL;
                revocationUrl = options.revocationUrl || _defaultConfig_1.PROD_REVOCATION_URL;
                break;
            case 'staging':
                issuerUrl = options.issuerUrl || _defaultConfig_1.STAGING_ISSUER_URL;
                registryUrl = options.registryUrl || _defaultConfig_1.STAGING_REGISTRY_URL;
                verifierUrl = options.verifierUrl || _defaultConfig_1.STAGING_VERIFIER_URL;
                vaultUrl = options.vaultUrl || _defaultConfig_1.STAGING_VAULT_URL;
                keyStorageUrl = options.keyStorageUrl || _defaultConfig_1.STAGING_KEY_STORAGE_URL;
                clientId = _defaultConfig_1.STAGING_COGNITO_CLIENT_ID;
                userPoolId = _defaultConfig_1.STAGING_COGNITO_USER_POOL_ID;
                phoneIssuerBasePath = options.phoneIssuerBasePath || _defaultConfig_1.STAGING_PHONE_ISSUER_BASE_PATH;
                emailIssuerBasePath = options.emailIssuerBasePath || _defaultConfig_1.STAGING_EMAIL_ISSUER_BASE_PATH;
                metricsUrl = _defaultConfig_1.STAGING_METRICS_URL;
                revocationUrl = options.revocationUrl || _defaultConfig_1.STAGING_REVOCATION_URL;
                break;
        }
        const accessApiKey = CommonNetworkMember_1._setAccessApiKey(options);
        const { storageRegion } = options;
        return {
            env,
            storageRegion,
            accessApiKey,
            issuerUrl,
            registryUrl,
            verifierUrl,
            vaultUrl,
            keyStorageUrl,
            userPoolId,
            clientId,
            phoneIssuerBasePath,
            emailIssuerBasePath,
            metricsUrl,
            revocationUrl,
        };
    }
    /**
     * @description Returns user's encrypted seed
     * @returns encrypted seed
     */
    get encryptedSeed() {
        return this._encryptedSeed;
    }
    /**
     * @description Returns user's accessToken
     * @returns encrypted seed
     */
    get accessToken() {
        return this.cognitoUserTokens.accessToken;
    }
    /**
     * @description Returns user's password
     * @returns encrypted seed
     */
    get password() {
        return this._password;
    }
    /**
     * @description Checks if registration for the user was completed
     * @param username - a valid email, phone number or arbitrary username
     * @param options - object with environment, staging is default { env: 'staging' }
     * @returns `true` if user is uncofirmed in Cognito, and `false` otherwise.
     */
    static isUserUnconfirmed(username, options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: true, value: options },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            const normalizedUsername = normalizeUsername_1.normalizeUsername(username);
            return cognitoService.isUserUnconfirmed(normalizedUsername);
        });
    }
    /**
     * @description Initilizes instance of SDK from seed
     * @param seedHexWithMethod - seed for derive keys in string hex format
     * @param options - optional parameter { registryUrl: 'https://affinity-registry.dev.affinity-project.org' }
     * @param password - optional password, will be generated, if not provided
     * @returns initialized instance of SDK
     */
    static fromSeed(seedHexWithMethod, options = {}, password = null) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: seedHexWithMethod },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
                { isArray: false, type: 'string', isRequired: false, value: password },
            ]);
            let passwordBuffer;
            if (password) {
                passwordBuffer = common_1.KeysService.normalizePassword(password);
            }
            else {
                passwordBuffer = yield randomBytes_1.randomBytes(32);
                password = passwordBuffer.toString('hex');
            }
            const encryptedSeedWithInitializationVector = yield common_1.KeysService.encryptSeed(seedHexWithMethod, passwordBuffer);
            return new this(password, encryptedSeedWithInitializationVector, options);
        });
    }
    /**
     * @description Parses JWT and returns DID
     * @param jwt
     * @returns DID of entity who signed JWT
     */
    static getDidFromToken(jwt) {
        // await ParametersValidator.validateSync(
        //   [
        //     { isArray: false, type: 'jwt', isRequired: true, value: jwt }
        //   ]
        // )
        return common_1.JwtService.getDidFromToken(jwt);
    }
    /**
     * @description Returns hex of public key from DID document
     * @param didDocument - user's DID document
     * @returns public key hex
     */
    getPublicKeyHexFromDidDocument(didDocument) {
        // await ParametersValidator.validateSync(
        //   [
        //     { isArray: false, type: 'object', isRequired: true, value: didDocument }
        //   ]
        // )
        // TODO: review: in general case - need to find section at didDocument.publicKey where id === keyId
        const { publicKeyHex } = didDocument.publicKey[0];
        return publicKeyHex;
    }
    /**
     * @description Creates DID and anchors it
     * 1. generate seed/keys
     * 2. build DID document
     * 3. sign DID document
     * 4. store DID document in IPFS
     * 5. anchor DID with DID document ID from IPFS
     * @param password - encryption key which will be used to encrypt randomly created seed/keys pair
     * @param options - optional parameter { registryUrl: 'https://affinity-registry.dev.affinity-project.org' }
     * @returns
     *
     * did - hash from public key (your decentralized ID)
     *
     * encryptedSeed - seed is encrypted by provided password. Seed - it's a source to derive your keys
     */
    static register(password, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: password },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            // const { registryUrl } = CommonNetworkMember.setEnvironmentVarialbles(options)
            /* istanbul ignore next: seems options is {} if not passed to the method */
            options = options || {};
            const didMethod = options.didMethod || _defaultConfig_1.DEFAULT_DID_METHOD;
            const seed = yield CommonNetworkMember_1.generateSeed(didMethod);
            const seedHex = seed.toString('hex');
            const seedWithMethod = `${seedHex}++${didMethod}`;
            const { encryptedSeed } = yield this.fromSeed(seedWithMethod, options, password);
            const keysService = new common_1.KeysService(encryptedSeed, password);
            const didDocumentService = new common_1.DidDocumentService(keysService);
            const didDocument = yield didDocumentService.buildDidDocument();
            const did = didDocument.id;
            yield CommonNetworkMember_1.anchorDid(encryptedSeed, password, didDocument, 0, options);
            return { did, encryptedSeed };
        });
    }
    static anchorDid(encryptedSeed, password, didDocument, nonce, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const { registryUrl } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const accessApiKey = CommonNetworkMember_1._setAccessApiKey(options);
            const api = new ApiService_1.default(registryUrl, null, null, { accessApiKey });
            const did = didDocument.id;
            const keysService = new common_1.KeysService(encryptedSeed, password);
            const { seed, didMethod } = keysService.decryptSeed();
            const seedHex = seed.toString('hex');
            /* istanbul ignore next: seems options is {} if not passed to the method */
            if (didMethod !== _defaultConfig_1.ELEM_DID_METHOD) {
                const signedDidDocument = yield keysService.signDidDocument(didDocument);
                const { body: bodyDidDocument } = yield api.execute('registry.PutDocumentInIpfs', {
                    params: { document: signedDidDocument },
                });
                const didDocumentAddress = bodyDidDocument.hash;
                const { body: { digestHex }, } = yield api.execute('registry.CreateAnchorTransaction', { params: { nonce, did, didDocumentAddress } });
                let transactionSignatureJson = '';
                if (digestHex && digestHex !== '') {
                    transactionSignatureJson = yield keysService.createTransactionSignature(digestHex, seedHex);
                }
                const transactionPublicKey = common_1.KeysService.getAnchorTransactionPublicKey(seedHex, didMethod);
                const ethereumPublicKeyHex = transactionPublicKey.toString('hex');
                yield api.execute('registry.AnchorDid', {
                    params: { did, didDocumentAddress, ethereumPublicKeyHex, transactionSignatureJson, nonce },
                });
            }
            // NOTE: for metrics purpose in case of ELEM method
            if (didMethod === _defaultConfig_1.ELEM_DID_METHOD) {
                try {
                    yield api.execute('registry.AnchorDid', {
                        params: { did, didDocumentAddress: '', ethereumPublicKeyHex: '', transactionSignatureJson: '' },
                    });
                }
                catch (error) {
                    console.log('to check logs at the backend', error);
                }
            }
        });
    }
    /**
     * @description Resolves DID
     * @param did - decentralized ID
     * @returns DID document
     */
    resolveDid(did) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: 'did', isRequired: true, value: did }]);
            const params = { did };
            const { body } = yield this._api.execute('registry.ResolveDid', { params });
            const { didDocument } = body;
            return didDocument;
        });
    }
    /**
     * @description Update DidDocument , supporting only jolo method at this point
     * @param didDocument - updated did document
     * @returns void
     */
    updateDidDocument(didDocument) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: validate didDocument structure
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: 'object', isRequired: true, value: didDocument }]);
            const did = didDocument.id;
            const isJoloMethod = did.startsWith('did:jolo');
            if (!isJoloMethod) {
                throw new SdkError_1.default('COR-20', { did });
            }
            const instanceDid = this.did;
            if (instanceDid !== did) {
                throw new SdkError_1.default('COR-21', { did, instanceDid });
            }
            const keysService = new common_1.KeysService(this._encryptedSeed, this._password);
            const { seed, didMethod } = keysService.decryptSeed();
            const seedHex = seed.toString('hex');
            const transactionPublicKey = common_1.KeysService.getAnchorTransactionPublicKey(seedHex, didMethod);
            const ethereumPublicKeyHex = transactionPublicKey.toString('hex');
            const { body: { transactionCount }, } = yield this._api.execute('registry.TransactionCount', {
                params: { ethereumPublicKeyHex },
            });
            const nonce = transactionCount;
            yield CommonNetworkMember_1.anchorDid(this._encryptedSeed, this._password, didDocument, nonce, this._sdkOptions);
        });
    }
    /**
     * @description Pulls encrypted seed from Affinity Guardian Wallet
     * 1. get AWS cognito access token
     * 2. using access token pull encrypted seed from Affinity Guardian Wallet
     * associated with this AWS Cognito userId
     * @param username - email or phone number used to create Affinity user
     * @param password - password used on create Affinity user
     */
    pullEncryptedSeed(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: 'string', isRequired: true, value: password },
            ]);
            const encryptedSeed = yield this._walletStorageService.pullEncryptedSeed(username, password);
            return encryptedSeed;
        });
    }
    /**
     * @description Saves encrypted seed to Guardian Wallet
     * @param username - email/phoneNumber, registered in Cognito
     * @param password - password for Cognito user
     * @param token - Cognito access token, required for authorization.
     * If not provided, in order to get it, sign in to Cognito will be initiated.
     */
    storeEncryptedSeed(username, password, token = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: 'string', isRequired: true, value: password },
                { isArray: false, type: 'jwt', isRequired: false, value: token },
            ]);
            const { userPoolId, clientId } = this._sdkOptions;
            let accessToken = token;
            /* istanbul ignore else: code simplicity */
            if (!token) {
                const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
                password = normalizeShortPassword_1.normalizeShortPassword(password, username);
                this.cognitoUserTokens = yield cognitoService.signIn(username, password);
                accessToken = this.cognitoUserTokens.accessToken;
            }
            const { seedHexWithMethod } = this._keysService.decryptSeed();
            const encryptionKey = yield WalletStorageService_1.default.pullEncryptionKey(accessToken);
            yield async_retry_1.default((bail) => __awaiter(this, void 0, void 0, function* () {
                const errorCodes = ['COR-1', 'WAL-2'];
                try {
                    yield this._walletStorageService.storeEncryptedSeed(accessToken, seedHexWithMethod, encryptionKey);
                }
                catch (error) {
                    if (errorCodes.indexOf(error.code) >= 0) {
                        // If it's a known error we can bail out of the retry and that error will be what's thrown
                        bail(error);
                        return;
                    }
                    else {
                        // Otherwise we wrap the error and throw that,
                        // this will trigger a retry until "retries" count is met
                        throw new SdkError_1.default('COR-18', { accessToken }, error);
                    }
                }
            }), { retries: 3 });
        });
    }
    /**
     * @description Initiates passwordless login to Affinity
     * @param username - email/phoneNumber, registered in Cognito
     * @param options - optional parameters with specified environment
     * @returns token
     */
    static passwordlessLogin(username, options = {}, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
                { isArray: false, type: shared_dto_1.MessageParameters, isRequired: false, value: messageParameters },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            const token = yield cognitoService.signInWithUsername(username, messageParameters);
            // prettier-ignore
            return token;
        });
    }
    /**
     * @description Completes login
     * @param token - received from #passwordlessLogin method
     * @param confirmationCode - OTP sent by AWS Cognito/SES
     * @param options - optional parameters for CommonNetworkMember initialization
     * @returns initialized instance of SDK
     */
    static completeLoginChallenge(token, confirmationCode, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: token },
                { isArray: false, type: 'confirmationCode', isRequired: true, value: confirmationCode },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { keyStorageUrl, userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            /* istanbul ignore next: seems options is {} if not passed to the method */
            options = options || {};
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            options.cognitoUserTokens = yield cognitoService.completeLoginChallenge(token, confirmationCode);
            const { accessToken } = options.cognitoUserTokens;
            const encryptedSeed = yield WalletStorageService_1.default.pullEncryptedSeed(accessToken, keyStorageUrl, options);
            const encryptionKey = yield WalletStorageService_1.default.pullEncryptionKey(accessToken);
            return new this(encryptionKey, encryptedSeed, options);
        });
    }
    getShareCredential(credentialShareRequestToken, options) {
        const { credentials } = options;
        const credentialShareRequest = CommonNetworkMember_1.fromJWT(credentialShareRequestToken);
        const types = this.getCredentialTypes(credentialShareRequest);
        const filteredCredentials = credentials.filter((cred) => {
            return types.includes(cred.type[1]);
        });
        return filteredCredentials;
    }
    /**
     * @description Retrieves a VC based on signup information
     * @param idToken - idToken received from cognito
     * @returns an object with a flag, identifying whether new account was created, and initialized instance of SDK
     */
    getSignupCredentials(idToken, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: idToken },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { keyStorageUrl, registryUrl } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const credentialOfferToken = yield WalletStorageService_1.default.getCredentialOffer(idToken, keyStorageUrl, options);
            const credentialOfferResponseToken = yield this.createCredentialOfferResponseToken(credentialOfferToken);
            options.keyStorageUrl = keyStorageUrl;
            options.registryUrl = registryUrl;
            return WalletStorageService_1.default.getSignedCredentials(idToken, credentialOfferResponseToken, options);
        });
    }
    /**
     * @description Signs out current user
     */
    signOut(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options }]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            if (this.cognitoUserTokens) {
                yield this._refreshCognitoUserTokens(options);
                const { accessToken } = this.cognitoUserTokens;
                yield cognitoService.signOut(accessToken);
            }
            sessionStorageHandler_1.clearUserTokensFromSessionStorage(userPoolId);
        });
    }
    /* istanbul ignore next: private method */
    _refreshCognitoUserTokens(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            const { expiresIn, refreshToken } = this.cognitoUserTokens;
            const isAccessTokenExpired = Date.now() > expiresIn;
            if (isAccessTokenExpired) {
                this.cognitoUserTokens = yield cognitoService.refreshUserSessionTokens(refreshToken);
            }
        });
    }
    /**
     * @description Initiates reset password flow
     * @param username - email/phoneNumber, registered in Cognito
     * @param options - optional parameters with specified environment
     */
    static forgotPassword(username, options = {}, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            yield cognitoService.forgotPassword(username, messageParameters);
        });
    }
    /**
     * @description Completes reset password flow
     * @param username - email/phoneNumber, registered in Cognito
     * @param confirmationCode - OTP sent by AWS Cognito/SES
     * @param newPassword - new password
     * @param options - optional parameters with specified environment
     */
    static forgotPasswordSubmit(username, confirmationCode, newPassword, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: 'confirmationCode', isRequired: true, value: confirmationCode },
                { isArray: false, type: 'string', isRequired: true, value: newPassword },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            yield cognitoService.forgotPasswordSubmit(username, confirmationCode, newPassword);
        });
    }
    /**
     * @description Logins to Affinity with login and password
     * @param username - email/phoneNumber, registered in Cognito
     * @param password - password for Cognito user
     * @param options - optional parameters for CommonNetworkMember initialization
     * @returns initialized instance of SDK
     */
    static fromLoginAndPassword(username, password, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: 'password', isRequired: true, value: password },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { keyStorageUrl, userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            password = normalizeShortPassword_1.normalizeShortPassword(password, username);
            options.cognitoUserTokens = yield cognitoService.signIn(username, password);
            const { accessToken } = options.cognitoUserTokens;
            const accessApiKey = CommonNetworkMember_1._setAccessApiKey(options);
            const encryptedSeed = yield WalletStorageService_1.default.pullEncryptedSeed(accessToken, keyStorageUrl, { accessApiKey });
            const encryptionKey = yield WalletStorageService_1.default.pullEncryptionKey(accessToken);
            return new this(encryptionKey, encryptedSeed, options);
        });
    }
    static _validateKeys(keyParams) {
        const { encryptedSeed, password } = keyParams;
        let didMethod;
        try {
            const keysService = new common_1.KeysService(encryptedSeed, password);
            didMethod = keysService.decryptSeed().didMethod;
        }
        catch (error) {
            throw new SdkError_1.default('COR-24', {}, error);
        }
        if (!_defaultConfig_1.SUPPORTED_DID_METHODS.includes(didMethod)) {
            const supportedDidMethods = _defaultConfig_1.SUPPORTED_DID_METHODS.join(', ');
            throw new SdkError_1.default('COR-25', { didMethod, supportedDidMethods });
        }
    }
    /**
     * @description Initiates sign up flow to Affinity wallet with already created did
     * @param keyParams - { ecnryptedSeed, password } - previously created keys to be storead at wallet.
     * @param username - arbitrary username, email or phoneNumber
     * @param password - is required if arbitrary username was provided.
     * It is optional and random one will be generated, if not provided when
     * email or phoneNumber was given as a username.
     * @param options - optional parameters with specified environment
     * @param messageParameters - optional parameters with specified welcome message
     * @returns token or, in case when arbitrary username was used, it returns
     * initialized instance of SDK
     */
    static signUpWithExistsEntity(keyParams, username, password, options = {}, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: shared_dto_1.KeyParams, isRequired: true, value: keyParams }]);
            CommonNetworkMember_1._validateKeys(keyParams);
            const { token, isUsername } = yield CommonNetworkMember_1._signUp(username, password, options, messageParameters);
            if (!isUsername) {
                return token;
            }
            return CommonNetworkMember_1.confirmSignUpWithExistsEntity(keyParams, token, '', options);
        });
    }
    static _signUp(username, password, options = {}, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { isUsername } = validateUsername_1.validateUsername(username);
            let passwordMustBeProvided = false;
            if (isUsername) {
                passwordMustBeProvided = true;
            }
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: 'password', isRequired: passwordMustBeProvided, value: password },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
                { isArray: false, type: shared_dto_1.MessageParameters, isRequired: false, value: messageParameters },
            ]);
            const randomPassword = (yield randomBytes_1.randomBytes(32)).toString('hex');
            // Make first found letter uppercase because hex string doesn't meet password requirements
            const normalizedPassword = randomPassword.replace(/[a-f]/, 'A');
            password = password || normalizedPassword;
            password = normalizeShortPassword_1.normalizeShortPassword(password, username);
            const { userPoolId, clientId, keyStorageUrl } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            yield cognitoService.signUp(username, password, messageParameters, Object.assign(Object.assign({}, options), { keyStorageUrl }));
            const token = `${username}::${password}`;
            return { token, isUsername };
        });
    }
    /**
     * @description Initiates sign up flow
     * @param username - arbitrary username, email or phoneNumber
     * @param password - is required if arbitrary username was provided.
     * It is optional and random one will be generated, if not provided when
     * email or phoneNumber was given as a username.
     * @param options - optional parameters with specified environment
     * @param messageParameters - optional parameters with specified welcome message
     * @returns token or, in case when arbitrary username was used, it returns
     * initialized instance of SDK
     */
    static signUp(username, password, options = {}, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const { token, isUsername } = yield CommonNetworkMember_1._signUp(username, password, options, messageParameters);
            if (!isUsername) {
                return token;
            }
            return CommonNetworkMember_1.confirmSignUp(token, '', options);
        });
    }
    /**
     * @description Completes sign up flow with already created did
     *       (as result created keys will be stored at the Affinity Wallet)
     * NOTE: no need calling this method in case of arbitrary username was given,
     *       as registration is already completed
     * @param keyParams - { ecnryptedSeed, password } - previously created keys to be storead at wallet.
     * @param token - Token returned by signUpWithExistsEntity method.
     * @param confirmationCode - OTP sent by AWS Cognito/SES.
     * NOTE: confirmationCode is required if email/phoneNumber was given
     *       on #signUp as a username
     * @param options - optional parameters for CommonNetworkMember initialization
     * @returns initialized instance of SDK
     */
    static confirmSignUpWithExistsEntity(keyParams, token, confirmationCode, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const [username] = token.split('::');
            const { isEmailValid, isPhoneNumberValid } = validateUsername_1.validateUsername(username);
            const parametersToValidate = [
                { isArray: false, type: shared_dto_1.KeyParams, isRequired: true, value: keyParams },
                { isArray: false, type: 'string', isRequired: true, value: token },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ];
            if (isEmailValid || isPhoneNumberValid) {
                parametersToValidate.push({ isArray: false, type: 'confirmationCode', isRequired: true, value: confirmationCode });
            }
            yield ParametersValidator_1.ParametersValidator.validate(parametersToValidate);
            return CommonNetworkMember_1._confirmSignUp(token, confirmationCode, keyParams, options);
        });
    }
    static _confirmSignUpUser(token, confirmationCode, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const [username] = token.split('::');
            const { isUsername } = validateUsername_1.validateUsername(username);
            const fullOptions = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const { userPoolId, clientId } = fullOptions;
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            if (isUsername) {
                yield WalletStorageService_1.default.adminConfirmUser(username, fullOptions);
            }
            else {
                yield cognitoService.confirmSignUp(username, confirmationCode);
            }
            return cognitoService;
        });
    }
    static _confirmSignUp(token, confirmationCode, keyParams = {}, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const parts = token.split('::');
            const username = parts[0];
            let password = parts[1];
            let passwordHash;
            let encryptedSeed;
            if (keyParams.encryptedSeed) {
                encryptedSeed = keyParams.encryptedSeed;
                passwordHash = keyParams.password;
            }
            else {
                passwordHash = WalletStorageService_1.default.hashFromString(password);
                const result = yield this.register(passwordHash, options);
                encryptedSeed = result.encryptedSeed;
            }
            const cognitoService = yield CommonNetworkMember_1._confirmSignUpUser(token, confirmationCode, options);
            password = normalizeShortPassword_1.normalizeShortPassword(password, username);
            options.cognitoUserTokens = yield cognitoService.signIn(username, password);
            const { accessToken } = options.cognitoUserTokens;
            const encryptionKey = yield WalletStorageService_1.default.pullEncryptionKey(accessToken);
            const updatedEncryptedSeed = yield CommonNetworkMember_1.reencryptSeedWithEncryptionKey(encryptedSeed, passwordHash, encryptionKey);
            const commonNetworkMember = new this(encryptionKey, updatedEncryptedSeed, options);
            const skipBackupEncryptedSeed = options && options.skipBackupEncryptedSeed;
            if (skipBackupEncryptedSeed) {
                return commonNetworkMember;
            }
            yield commonNetworkMember.storeEncryptedSeed('', '', accessToken);
            return commonNetworkMember;
        });
    }
    /**
     * @description Completes sign up flow
     * NOTE: no need calling this method in case of arbitrary username was given,
     *       as registration is already completed
     * @param confirmationCode - OTP sent by AWS Cognito/SES.
     * NOTE: confirmationCode is required if email/phoneNumber was given
     *       on #signUp as a username
     * @param options - optional parameters for CommonNetworkMember initialization
     * @returns initialized instance of SDK
     */
    static confirmSignUp(token, confirmationCode, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const [username] = token.split('::');
            const { isEmailValid, isPhoneNumberValid } = validateUsername_1.validateUsername(username);
            const parametersToValidate = [
                { isArray: false, type: 'string', isRequired: true, value: token },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ];
            if (isEmailValid || isPhoneNumberValid) {
                parametersToValidate.push({ isArray: false, type: 'confirmationCode', isRequired: true, value: confirmationCode });
            }
            yield ParametersValidator_1.ParametersValidator.validate(parametersToValidate);
            return CommonNetworkMember_1._confirmSignUp(token, confirmationCode, undefined, options);
        });
    }
    /* To cover scenario when registration failed and private key is not saved:
     *    1. seed is generated before user is confirmed in Cognito
     *    2. encrypt seed with user's password
     *    3. confirm user in Cognito, if registration is successful
     *    4. get user's encryptionKey
     *    5. re-encrypt user's seed with encryptionKey
     */
    /* istanbul ignore next: private method */
    static reencryptSeedWithEncryptionKey(encryptedSeed, password, encryptionKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const { seedHexWithMethod } = common_1.KeysService.decryptSeed(encryptedSeed, password);
            const encryptionKeyBuffer = common_1.KeysService.normalizePassword(encryptionKey);
            return common_1.KeysService.encryptSeed(seedHexWithMethod, encryptionKeyBuffer);
        });
    }
    /**
     * @description Resends OTP for sign up flow
     * @param username - email/phoneNumber, registered and unconfirmed in Cognito
     * @param options - optional parameters with specified environment
     */
    static resendSignUpConfirmationCode(username, options = {}, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            yield cognitoService.resendSignUp(username, messageParameters);
        });
    }
    /**
     * @description Initiates passwordless sign in of an existing user,
     * or signs up a new one, if user was not registered
     * @param username - email/phoneNumber, registered in Cognito
     * @param options - optional parameters with specified environment
     * @returns token
     */
    static signIn(username, options = {}, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: username },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
                { isArray: false, type: shared_dto_1.MessageParameters, isRequired: false, value: messageParameters },
            ]);
            // NOTE: This is a passwordless login/sign up flow,
            //       case when user signs up more often
            let token;
            try {
                token = yield CommonNetworkMember_1.signUp(username, null, options, messageParameters);
            }
            catch (error) {
                if (error.code === 'COR-7') {
                    token = yield CommonNetworkMember_1.passwordlessLogin(username, options, messageParameters);
                }
                else {
                    throw error;
                }
            }
            return token;
        });
    }
    /**
     * @description Completes sign in
     * @param token - received from #signIn method
     * @param confirmationCode - OTP sent by AWS Cognito/SES
     * @param options - optional parameters for CommonNetworkMember initialization
     * @returns an object with a flag, identifying whether new account was created, and initialized instance of SDK
     */
    static confirmSignIn(token, confirmationCode, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: token },
                { isArray: false, type: 'confirmationCode', isRequired: true, value: confirmationCode },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            let commonNetworkMember;
            // NOTE: loginToken = '{"ChallengeName":"CUSTOM_CHALLENGE","Session":"...","ChallengeParameters":{"USERNAME":"...","email":"..."}}'
            //       signUpToken = 'username::password'
            const isSignUpToken = token.split('::')[1] !== undefined;
            if (isSignUpToken) {
                commonNetworkMember = yield this.confirmSignUp(token, confirmationCode, options);
                return { isNew: true, commonNetworkMember };
            }
            commonNetworkMember = yield this.completeLoginChallenge(token, confirmationCode, options);
            return { isNew: false, commonNetworkMember };
        });
    }
    /* istanbul ignore next */
    _getCognitoUserTokensForUser(options = {}) {
        if (this.cognitoUserTokens) {
            return this.cognitoUserTokens;
        }
        const { userPoolId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
        this.cognitoUserTokens = sessionStorageHandler_1.readUserTokensFromSessionStorage(userPoolId);
        return this.cognitoUserTokens;
    }
    /**
     * @description Initiates change user password
     * @param oldPassword
     * @param newPassword
     * @param options - optional parameters with specified environment
     */
    changePassword(oldPassword, newPassword, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: oldPassword },
                { isArray: false, type: 'string', isRequired: true, value: newPassword },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const { accessToken } = yield this._getCognitoUserTokensForUser(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            yield cognitoService.changePassword(accessToken, oldPassword, newPassword);
        });
    }
    /**
     * @description Initiates change user attribute (email/phoneNumber) flow
     * @param newUsername - new email/phoneNumber
     * @param options - optional parameters with specified environment
     */
    // NOTE: operation is used for change the attribute, not username. Consider renaming
    //       New email/phoneNumber can be useded as a username to login.
    changeUsername(newUsername, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: newUsername },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const { accessToken } = yield this._getCognitoUserTokensForUser(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            yield cognitoService.changeUsername(accessToken, newUsername);
        });
    }
    /**
     * @description Completes change user attribute (email/phoneNumber) flow
     * @param newUsername - new email/phoneNumber
     * @param confirmationCode - OTP sent by AWS Cognito/SES
     * @param options - optional parameters with specified environment
     */
    confirmChangeUsername(newUsername, confirmationCode, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: newUsername },
                { isArray: false, type: 'confirmationCode', isRequired: true, value: confirmationCode },
                { isArray: false, type: shared_dto_1.SdkOptions, isRequired: false, value: options },
            ]);
            const { userPoolId, clientId } = CommonNetworkMember_1.setEnvironmentVarialbles(options);
            const { accessToken } = yield this._getCognitoUserTokensForUser(options);
            const cognitoService = new CognitoService_1.default({ userPoolId, clientId });
            yield cognitoService.confirmChangeUsername(accessToken, newUsername, confirmationCode);
        });
    }
    /**
     * @description Generates random seed from which keys could be derived
     */
    static generateSeed(didMethod = _defaultConfig_1.DEFAULT_DID_METHOD) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: 'didMethod', isRequired: true, value: didMethod }]);
            let seed;
            switch (didMethod) {
                case 'jolo':
                    seed = yield randomBytes_1.randomBytes(32);
                    break;
                default:
                    seed = yield randomBytes_1.randomBytes(32);
            }
            return seed;
        });
    }
    /* istanbul ignore next: protected method */
    saveEncryptedCredentials(data, storageRegion) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._walletStorageService.saveCredentials(data, storageRegion);
        });
    }
    /**
     * @description Deletes all credentials from the wallet
     */
    deleteAllCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._walletStorageService.deleteAllCredentials();
        });
    }
    /**
     * @description Deletes credential by index
     */
    /* istanbul ignore next: protected method */
    deleteCredentialByIndex(index) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._walletStorageService.deleteCredentialByIndex(index);
        });
    }
    /**
     * @description Creates JWT of credential offer request
     * @param offeredCredentials - array of credentials to be offered
     * @param options - optional, JwtOptions containing:
     *
     *   audienceDid (string) - audience of generated token
     *
     *   expiresAt (isoString) - expire date-time of generated token
     *
     *   nonce (string) - nonce/jti of generated token
     *
     *   callbackUrl (string)
     * @returns JWT
     */
    generateCredentialOfferRequestToken(offeredCredentials, options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: true, type: shared_dto_1.OfferedCredential, isRequired: true, value: offeredCredentials },
                { isArray: false, type: shared_dto_1.JwtOptions, isRequired: false, value: options },
            ]);
            const params = { offeredCredentials };
            /* istanbul ignore else: else not required */
            if (options) {
                const { audienceDid, expiresAt, nonce, callbackUrl } = options;
                params.audienceDid = audienceDid;
                params.expiresAt = expiresAt;
                params.nonce = nonce;
                params.callbackUrl = callbackUrl;
            }
            const { body: { credentialOffer }, } = yield this._api.execute('issuer.BuildCredentialOffer', { params });
            const signedObject = this._keysService.signJWT(credentialOffer, this.didDocumentKeyId);
            return this._jwtService.encodeObjectToJWT(signedObject);
        });
    }
    generateDidAuthRequest(options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: shared_dto_1.JwtOptions, isRequired: false, value: options }]);
            return this.generateCredentialShareRequestToken([], null, options);
        });
    }
    /**
     * @description Creates JWT of credential share request
     * @param credentialRequirements - array of credential requirements with credential types
     * @param issuerDid - DID of the issuer
     * @param options - optional, JwtOptions containing:
     *
     *   audienceDid (string) - audience of generated token
     *
     *   expiresAt (isoString) - expire date-time of generated token
     *
     *   nonce (number) - nonce/jti of generated token
     * @returns JWT
     */
    generateCredentialShareRequestToken(credentialRequirements, issuerDid = undefined, options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: true, type: shared_dto_1.CredentialRequirement, isRequired: true, value: credentialRequirements },
                { isArray: false, type: 'did', isRequired: false, value: issuerDid },
                { isArray: false, type: shared_dto_1.JwtOptions, isRequired: false, value: options },
            ]);
            const params = { credentialRequirements, issuerDid };
            /* istanbul ignore else: else not required */
            if (options) {
                const { audienceDid, expiresAt, nonce, callbackUrl } = options;
                params.audienceDid = audienceDid;
                params.expiresAt = expiresAt;
                params.nonce = nonce;
                params.callbackUrl = callbackUrl;
            }
            const { body: { credentialShareRequest }, } = yield this._api.execute('verifier.BuildCredentialRequest', { params });
            const signedObject = this._keysService.signJWT(credentialShareRequest, this.didDocumentKeyId);
            return this._jwtService.encodeObjectToJWT(signedObject);
        });
    }
    /**
     * @description Creates JWT of credential offer response
     * @param credentialOfferToken - JWT with offered credentials
     * @returns JWT
     */
    createCredentialOfferResponseToken(credentialOfferToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: 'jwt', isRequired: true, value: credentialOfferToken }]);
            const credentialOfferResponse = yield this._holderService.buildCredentialOfferResponse(credentialOfferToken);
            const signedObject = this._keysService.signJWT(credentialOfferResponse, this.didDocumentKeyId);
            return this._jwtService.encodeObjectToJWT(signedObject);
        });
    }
    createDidAuthResponse(didAuthRequestToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([{ isArray: false, type: 'jwt', isRequired: true, value: didAuthRequestToken }]);
            return this.createCredentialShareResponseToken(didAuthRequestToken, []);
        });
    }
    // NOTE: to be removed after support of legacy credentials is dropped
    /* istanbul ignore next: private method */
    _validateSignedCredentialsSupportedStructures(credentials) {
        const errors = [];
        for (const credential of credentials) {
            const hasIssuedDate = typeof credential.issued !== 'undefined';
            const hasIssuanceDate = typeof credential.issuanceDate !== 'undefined';
            const isLegacyCredential = typeof credential.claim !== 'undefined';
            const hasCredentialSubject = typeof credential.credentialSubject !== 'undefined';
            if (isLegacyCredential) {
                if (!hasIssuedDate) {
                    const error = 'Parameter "issued" is missing for SignedCredential';
                    errors.push(error);
                }
                continue;
            }
            if (!hasIssuanceDate) {
                const error = 'Parameter "issuanceDate" is missing for SignedCredential';
                errors.push(error);
            }
            if (!hasCredentialSubject) {
                const error = 'Parameter "credentialSubject" is missing for SignedCredential';
                errors.push(error);
            }
        }
        const areCredentialsValid = errors.length === 0;
        if (!areCredentialsValid) {
            throw new SdkError_1.default('COR-1', { errors, credentials });
        }
    }
    /**
     * @description Creates JWT of credential share response
     * @param credentialShareRequestToken - JWT with the requested VCs
     * @param suppliedCredentials - array of signed credentials
     * @returns JWT
     */
    createCredentialShareResponseToken(credentialShareRequestToken, suppliedCredentials) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'jwt', isRequired: true, value: credentialShareRequestToken },
                { isArray: true, type: shared_dto_1.SignedCredential, isRequired: true, value: suppliedCredentials },
            ]);
            this._validateSignedCredentialsSupportedStructures(suppliedCredentials);
            const credentialResponse = yield this._holderService.buildCredentialResponse(credentialShareRequestToken, suppliedCredentials);
            const signedObject = this._keysService.signJWT(credentialResponse, this.didDocumentKeyId);
            return this._jwtService.encodeObjectToJWT(signedObject);
        });
    }
    /**
     * @description Returns user's DID
     * @returns DID
     */
    get did() {
        const didCalculated = this._did;
        /* istanbul ignore else: code simplicity */
        if (!didCalculated) {
            this._did = this._didDocumentService.getMyDid();
        }
        return this._did;
    }
    /**
     * @description Returns user's DID document key ID
     * @returns key ID
     */
    get didDocumentKeyId() {
        if (!this._didDocumentKeyId) {
            this._didDocumentKeyId = this._didDocumentService.getKeyId(this.did);
        }
        return this._didDocumentKeyId;
    }
    /**
     * @description Returns credential types credential request token
     * @param credentialRequest - object with credential requirements
     * @returns array of credential types
     */
    getCredentialTypes(credentialRequest) {
        // await ParametersValidator.validateSync(
        //   [
        //     { isArray: false, type: 'object', isRequired: true, value: credentialRequest }
        //   ]
        // )
        const { interactionToken } = credentialRequest.payload;
        const { credentialRequirements } = interactionToken;
        const credentialTypes = [];
        for (const credential of credentialRequirements) {
            if (_helpers_1.isW3cCredential(credential)) {
                const type = credential.type[1]; // seems its always next structure type: ['Credential', 'ProofOfEmailCredential|....']
                credentialTypes.push(type);
            }
        }
        return credentialTypes;
    }
    /**
     * @description Parses JWT token (request and response tokens of share and offer flows)
     * @param token - JWT
     * @returns parsed object from JWT
     */
    static fromJWT(token) {
        // await ParametersValidator.validateSync(
        //   [
        //     { isArray: false, type: 'jwt', isRequired: true, value: token }
        //   ]
        // )
        return common_1.JwtService.fromJWT(token);
    }
    buildRevocationListStatus(unsignedCredential, revocationServiceAccessToken) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const credentialId = unsignedCredential.id;
            const subjectDid = (_a = unsignedCredential.holder) === null || _a === void 0 ? void 0 : _a.id;
            const { credentialStatus, isPublisRequired, revocationListCredential, } = yield this._revocationService.buildRevocationListStatus({ credentialId, subjectDid }, revocationServiceAccessToken);
            const revokableUnsignedCredential = Object.assign({}, unsignedCredential, { credentialStatus });
            revokableUnsignedCredential['@context'].push('https://w3id.org/vc-revocation-list-2020/v1');
            if (isPublisRequired) {
                const signedListCredential = yield this._affinity.signCredential(revocationListCredential, this._encryptedSeed, this._password);
                signedListCredential.issuanceDate = new Date().toISOString();
                yield this._revocationService.publishRevocationListCredential(signedListCredential, revocationServiceAccessToken);
            }
            return revokableUnsignedCredential;
        });
    }
    revokeCredential(credentialId, revocationReason, revocationServiceAccessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const { revocationListCredential } = yield this._revocationService.revokeCredential(credentialId, revocationReason, revocationServiceAccessToken);
            const signedListCredential = yield this._affinity.signCredential(revocationListCredential, this._encryptedSeed, this._password);
            signedListCredential.issuanceDate = new Date().toISOString();
            yield this._revocationService.publishRevocationListCredential(signedListCredential, revocationServiceAccessToken);
        });
    }
    /**
     * @description Signs credentials
     * @param credentialOfferResponseToken - credential offer response JWT
     * @param credentialParams - params for credentials
     * @returns array of SignedCredential
     */
    signCredentials(credentialOfferResponseToken, credentialParams) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'jwt', isRequired: true, value: credentialOfferResponseToken },
                { isArray: true, type: 'object', isRequired: true, value: credentialParams },
            ]);
            const signedCredentials = [];
            const credentialOfferResponse = CommonNetworkMember_1.fromJWT(credentialOfferResponseToken);
            const { selectedCredentials } = credentialOfferResponse.payload.interactionToken;
            const credentialTypesThatCanBeSigned = selectedCredentials.map(({ type }) => type);
            for (const unsignedCredential of credentialParams) {
                const isCredentialOffered = unsignedCredential.type.some((type) => credentialTypesThatCanBeSigned.includes(type));
                if (!isCredentialOffered) {
                    continue;
                }
                const { credentialSubject, type, '@context': context, expirationDate } = unsignedCredential;
                const credentialMetadata = { type, context };
                const signedCredential = yield this.signCredential(credentialSubject, credentialMetadata, { credentialOfferResponseToken }, expirationDate);
                signedCredentials.push(signedCredential);
            }
            if (signedCredentials.length === 0) {
                throw new SdkError_1.default('COR-22', { credentialOfferResponseToken, credentialParams });
            }
            return signedCredentials;
        });
    }
    /**
     * @description Signs credential
     * @param claim - data which should be present in VC according to VC schema,
     * e.g. const claim = { ageOver: 18 }
     * @param claimMetadata - schema of credential
     * @param signCredentialOptionalInput - object with optional
     * credential offer response JWT and requester DID
     * @param expiresAt - optional, date-time when VC is to be expired
     * @returns signed credential object
     */
    signCredential(credentialSubject, claimMetadata, signCredentialOptionalInput, expiresAt) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'object', isRequired: true, value: credentialSubject },
                { isArray: false, type: shared_dto_1.ClaimMetadata, isRequired: true, value: claimMetadata },
                { isArray: false, type: shared_dto_1.SignCredentialOptionalInput, isRequired: true, value: signCredentialOptionalInput },
                { isArray: false, type: 'isoString', isRequired: false, value: expiresAt },
            ]);
            if (typeof expiresAt !== 'undefined' && new Date().getTime() > new Date(expiresAt).getTime()) {
                throw new Error('Expiry date should be greater than current date');
            }
            let { requesterDid } = signCredentialOptionalInput;
            const { credentialOfferResponseToken } = signCredentialOptionalInput;
            /* istanbul ignore else: code simplicity */
            if (credentialOfferResponseToken) {
                const credentialOfferResponse = common_1.JwtService.fromJWT(credentialOfferResponseToken);
                requesterDid = credentialOfferResponse.payload.iss;
            }
            const unsignedCredential = vc_common_1.buildVCV1Unsigned({
                skeleton: vc_common_1.buildVCV1Skeleton({
                    id: `claimId:${randomBytes_1.randomBytes(8).toString('hex')}`,
                    credentialSubject,
                    holder: { id: did_resolver_1.parse(requesterDid).did },
                    type: claimMetadata.type,
                    context: claimMetadata.context,
                }),
                issuanceDate: new Date().toISOString(),
                expirationDate: expiresAt ? new Date(expiresAt).toISOString() : undefined,
            });
            return this._affinity.signCredential(unsignedCredential, this._encryptedSeed, this._password);
        });
    }
    /**
     * @description Initiates the phone number verification flow
     * @param config - Configuration options
     * @param config.apiKey - They api access key to the issuer service
     * @param config.phoneNumber - The phone number to send the confirmation code to
     * @param config.isWhatsAppNumber - Whether the phone number is a WhatsApp number
     * @param config.id - The id of the request, this is for the caller to be able to identify the credential in the verify step
     * @param config.holder - The DID of the user who will recieve the VC (owner of the phone number)
     * @returns intitiate response data, including the status of the request
     */
    initiatePhoneCredential({ apiKey, phoneNumber, isWhatsAppNumber, id, holder, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: apiKey },
                { isArray: false, type: 'string', isRequired: true, value: phoneNumber },
                { isArray: false, type: 'boolean', isRequired: false, value: isWhatsAppNumber },
                { isArray: false, type: 'string', isRequired: true, value: id },
                { isArray: false, type: 'string', isRequired: true, value: holder },
            ]);
            return this._phoneIssuer.initiate({ apiKey, phoneNumber, isWhatsAppNumber, id, holder });
        });
    }
    /**
     * @description Finishes the phone number verification flow
     * @param config - Configuration options
     * @param config.apiKey - They api access key to the issuer service
     * @param config.code - The code the user recieved
     * @param config.id - The id of the request, must match the ID given in the initiate step
     * @param config.holder - The DID of the user who will recieve the VC (owner of the phone number)
     * @returns verify response data, including the issued VC(s)
     */
    verifyPhoneCredential({ apiKey, code, id, holder, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: apiKey },
                { isArray: false, type: 'string', isRequired: true, value: code },
                { isArray: false, type: 'string', isRequired: true, value: id },
                { isArray: false, type: 'string', isRequired: true, value: holder },
            ]);
            return this._phoneIssuer.verify({ apiKey, code, id, holder });
        });
    }
    /**
     * @description Initiates the email address verification flow
     * @param config - Configuration options
     * @param config.apiKey - They api access key to the issuer service
     * @param config.emailAddress - The email address to send the confirmation code to
     * @param config.id - The id of the request, this is for the caller to be able to identify the credential in the verify step
     * @param config.holder - The DID of the user who will recieve the VC (owner of the email address)
     * @returns intitiate response data, including the status of the request
     */
    initiateEmailCredential({ apiKey, emailAddress, id, holder, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: apiKey },
                { isArray: false, type: 'string', isRequired: true, value: emailAddress },
                { isArray: false, type: 'string', isRequired: true, value: id },
                { isArray: false, type: 'string', isRequired: true, value: holder },
            ]);
            return this._emailIssuer.initiate({ apiKey, emailAddress, id, holder });
        });
    }
    /**
     * @description Finishes the email address verification flow
     * @param config - Configuration options
     * @param config.apiKey - They api access key to the issuer service
     * @param config.code - The code the user recieved
     * @param config.id - The id of the request, must match the ID given in the initiate step
     * @param config.holder - The DID of the user who will recieve the VC (owner of the email address)
     * @returns verify response data, including the issued VC(s)
     */
    verifyEmailCredential({ apiKey, code, id, holder, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: apiKey },
                { isArray: false, type: 'string', isRequired: true, value: code },
                { isArray: false, type: 'string', isRequired: true, value: id },
                { isArray: false, type: 'string', isRequired: true, value: holder },
            ]);
            return this._emailIssuer.verify({ apiKey, code, id, holder });
        });
    }
    verifyDidAuthResponse(didAuthResponseToken, didAuthRequestToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'jwt', isRequired: true, value: didAuthResponseToken },
                { isArray: false, type: 'jwt', isRequired: false, value: didAuthRequestToken },
            ]);
            return this.verifyCredentialShareResponseToken(didAuthResponseToken, didAuthRequestToken);
        });
    }
    /**
     * @description Validates response token, verifies signature on provided VCs
     * and expiration date of VCs
     * @param credentialShareResponseToken - optional, used if need to check
     * response against request (when request have constrains)
     * @param credentialShareRequestToken - JWT with requested VC
     * @param shouldOwn - optional (boolean), can be passed as true,
     * when needed to verify if holder is a subject of VC
     * @returns { isValid, did, jti, suppliedCredentials, errors }
     *
     * isValid - boolean, result of the verification
     *
     * did - DID of the issuer
     *
     * jti - unique identifier for the JWT
     *
     * suppliedCredentials - array of supplied credentials
     */
    verifyCredentialShareResponseToken(credentialShareResponseToken, credentialShareRequest, shouldOwn = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let credentialShareRequestToken;
            const isFunction = credentialShareRequest instanceof Function;
            if (!isFunction) {
                credentialShareRequestToken = credentialShareRequest;
            }
            const paramsToValidate = [
                { isArray: false, type: 'jwt', isRequired: true, value: credentialShareResponseToken },
                { isArray: false, type: 'jwt', isRequired: false, value: credentialShareRequestToken },
                { isArray: false, type: 'boolean', isRequired: false, value: shouldOwn },
            ];
            yield ParametersValidator_1.ParametersValidator.validate(paramsToValidate);
            if (isFunction) {
                const credentialShareResponse = CommonNetworkMember_1.fromJWT(credentialShareResponseToken);
                const requestNonce = credentialShareResponse.payload.jti;
                credentialShareRequestToken = yield credentialShareRequest(requestNonce);
                if (!credentialShareRequestToken) {
                    throw new SdkError_1.default('COR-15', { credentialShareRequestToken });
                }
                try {
                    CommonNetworkMember_1.fromJWT(credentialShareRequestToken);
                }
                catch (error) {
                    throw new SdkError_1.default('COR-15', { credentialShareRequestToken });
                }
            }
            const response = yield this._holderService.verifyCredentialShareResponse(credentialShareResponseToken, credentialShareRequestToken, shouldOwn);
            const { isValid, did, jti, suppliedCredentials, errors } = response;
            const isTestEnvironment = process.env.NODE_ENV === 'test';
            if (isValid && !isTestEnvironment) {
                this._sendVCVerifiedPerPartyMetrics(suppliedCredentials);
            }
            return { isValid, did, nonce: jti, suppliedCredentials, errors };
        });
    }
    /* istanbul ignore next: private method */
    _sendVCVerifiedPerPartyMetrics(credentials) {
        const verifierDid = this.did;
        for (const credential of credentials) {
            const metadata = this._metricsService.parseVcMetadata(credential, affinity_metrics_lib_1.EventName.VC_VERIFIED_PER_PARTY);
            this._sendVCVerifiedPerPartyMetric(credential.id, verifierDid, metadata);
        }
    }
    /* istanbul ignore next: private method */
    _sendVCVerifiedPerPartyMetric(vcId, verifierDid, metadata) {
        const event = {
            component: this._component,
            link: vcId,
            secondaryLink: verifierDid,
            name: affinity_metrics_lib_1.EventName.VC_VERIFIED_PER_PARTY,
            category: affinity_metrics_lib_1.EventCategory.VC,
            subCategory: 'verify per party',
            metadata: metadata,
        };
        this._metricsService.send(event);
    }
    _sendVCSavedMetric(vcId, issuerId, metadata) {
        const event = {
            component: this._component,
            link: vcId,
            secondaryLink: issuerId,
            name: affinity_metrics_lib_1.EventName.VC_SAVED,
            category: affinity_metrics_lib_1.EventCategory.VC,
            subCategory: 'save',
            metadata: metadata,
        };
        this._metricsService.send(event);
    }
    _sendVCSavedMetrics(credentials) {
        for (const credential of credentials) {
            if (_helpers_1.isW3cCredential(credential)) {
                const metadata = this._metricsService.parseVcMetadata(credential, affinity_metrics_lib_1.EventName.VC_SAVED);
                const vcId = credential.id;
                // the issuer property could be either an URI string or an object with id propoerty
                // https://www.w3.org/TR/vc-data-model/#issuer
                let issuerId;
                const issuer = credential.issuer;
                if (typeof issuer === 'string') {
                    issuerId = issuer;
                }
                else {
                    issuerId = issuer.id;
                }
                this._sendVCSavedMetric(vcId, issuerId, metadata);
            }
        }
    }
    /**
     * @description Validates offer response against offer request
     * @param credentialOfferResponseToken - JWT with credential offer response
     * @param credentialOfferRequestToken - JWT with credential offer request
     * @returns { isValid, did, jti, selectedCredentials, errors }
     *
     * isValid - boolean, result of the verification
     *
     * did - DID of the issuer
     *
     * jti - unique identifier for the JWT
     *
     * selectedCredentials - array of selected credentials
     */
    verifyCredentialOfferResponseToken(credentialOfferResponseToken, credentialOfferRequestToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'jwt', isRequired: true, value: credentialOfferResponseToken },
                { isArray: false, type: 'jwt', isRequired: false, value: credentialOfferRequestToken },
            ]);
            const params = { credentialOfferResponseToken, credentialOfferRequestToken };
            const res = yield this._api.execute('issuer.VerifyCredentialOfferResponse', { params });
            const { isValid, issuer, jti, selectedCredentials, errors } = res.body;
            const did = common_1.DidDocumentService.keyIdToDid(issuer);
            return { isValid, did, nonce: jti, selectedCredentials, errors };
        });
    }
    /*
     * W3C-spec VP methods
     */
    /**
     * @description Creates JWT of presentation challenge
     * @param credentialRequirements - array of credential requirements with credential types
     * @param issuerDid - DID of the issuer
     * @param options - optional, JwtOptions containing:
     *
     *   audienceDid (string) - audience of generated token
     *
     *   expiresAt (isoString) - expire date-time of generated token
     *
     *   nonce (number) - nonce/jti of generated token
     * @returns JWT
     */
    generatePresentationChallenge(credentialRequirements, issuerDid = undefined, options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: true, type: shared_dto_1.CredentialRequirement, isRequired: true, value: credentialRequirements },
                { isArray: false, type: 'did', isRequired: false, value: issuerDid },
                { isArray: false, type: shared_dto_1.JwtOptions, isRequired: false, value: options },
            ]);
            const params = { credentialRequirements, issuerDid };
            /* istanbul ignore else: else not required */
            if (options) {
                const { audienceDid, expiresAt, nonce, callbackUrl } = options;
                params.audienceDid = audienceDid;
                params.expiresAt = expiresAt;
                params.nonce = nonce;
                params.callbackUrl = callbackUrl;
            }
            const { body: { credentialShareRequest }, } = yield this._api.execute('verifier.BuildCredentialRequest', { params });
            const signedObject = this._keysService.signJWT(credentialShareRequest);
            return this._jwtService.encodeObjectToJWT(signedObject);
        });
    }
    /**
     * @description Creates VP from VP challenge and credentials
     * @param credentialShareRequestToken - JWT with the requested VCs
     * @param suppliedCredentials - array of signed credentials
     * @returns VPV1
     */
    createPresentationFromChallenge(challenge, vcs, domain) {
        return __awaiter(this, void 0, void 0, function* () {
            yield ParametersValidator_1.ParametersValidator.validate([
                { isArray: false, type: 'jwt', isRequired: true, value: challenge },
                { isArray: true, type: 'VCV1', isRequired: true, value: vcs },
            ]);
            const requestedTypes = this.getCredentialTypes(CommonNetworkMember_1.fromJWT(challenge));
            return this._affinity.signPresentation({
                vp: vc_common_1.buildVPV1Unsigned({
                    id: `presentationId:${randomBytes_1.randomBytes(8).toString('hex')}`,
                    vcs: vcs.filter((vc) => requestedTypes.includes(vc.type[1])),
                    holder: { id: this.did },
                }),
                encryption: {
                    seed: this._encryptedSeed,
                    key: this._password,
                },
                purpose: {
                    challenge,
                    domain,
                },
            });
        });
    }
    /**
     * @description Validates a VP, and the contained VCs
     * @param vp - the presentation to be validated
     * when needed to verify if holder is a subject of VC
     * @returns { isValid, did, challenge, suppliedPresentations, errors }
     *
     * isValid - boolean, result of the verification
     *
     * did - DID of the VP issuer (holder of the shared VCs)
     *
     * challenge - unique identifier for the presentation.
     * You are responsible for checking this to protect against replay attacks
     *
     * suppliedPresentations - the validated presentation
     *
     * errors - array of validation errors
     */
    verifyPresentation(vp) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this._affinity.validatePresentation(vp);
            if (response.result === true) {
                // After validating the VP we need to validate the VP's challenge token
                // to ensure that it was issued from the correct DID and that it hasn't expired.
                try {
                    yield this._holderService.verifyPresentationChallenge(response.data.proof.challenge, this.did);
                }
                catch (error) {
                    return {
                        isValid: false,
                        suppliedPresentation: response.data,
                        errors: [error],
                    };
                }
                return {
                    isValid: true,
                    did: response.data.holder.id,
                    challenge: response.data.proof.challenge,
                    suppliedPresentation: response.data,
                };
            }
            else {
                return {
                    isValid: false,
                    suppliedPresentation: vp,
                    errors: [response.error],
                };
            }
        });
    }
};
CommonNetworkMember = CommonNetworkMember_1 = __decorate([
    common_1.profile()
], CommonNetworkMember);
exports.CommonNetworkMember = CommonNetworkMember;
//# sourceMappingURL=CommonNetworkMember.js.map